module.exports = __webpack_public_path__ + "img/index.849c29fe.png";